var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub_header"},[_c('h2',[_vm._v(_vm._s(this.title)+" ")]),_c('span',{staticClass:"sub_ham",on:{"click":_vm.OpenHam}}),(_vm.params.type!=='formList_all')?_c('span',{staticClass:"ap_sub_search"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }